<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17i9TAy/tc-custom/9780547416298.jpg?1698195281688" alt="This image is the cover for the book Rhyming Life & Death"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rhyming Life & Death
      </h1>
      <p class="bookDescription body article font2">
        <b>Fiction and reality merge inside the mind of a famous Israeli author in this “hilarious and profound . . . slyly philosophical novel” (<i>Booklist</i>).</b><br/><br/> In this novel, Amos Oz offers a prismatic portrait of the storytelling impulse, with an extended glimpse inside the mind of a celebrated, unnamed Author.<br/>  <br/> On a stiflingly hot night, the Author is in Tel Aviv to give a reading from his new book. As his attention wanders, he begins to invent lives for the strangers he sees around him: here, a self-styled cultural guru, Yakir Bar-Orian Zhitomirski; there, a love-starved professional reader, Rochele Reznik; to say nothing of Ricky the waitress, the real object of his desires. Reality and fiction blend in this ingenious, poignant work by the author of <i>A Tale of Love and Darkness, </i>a winner of the Koret Jewish Book Award.<br/>  <br/> “A fable on themes of sex, death and writing pitched somewhere between the fictional universes of JM Coetzee and Milan Kundera.” — <i>The Guardian</i><br/>  <br/> “The witty and melancholy recorder of his country’s brilliant sufficiencies. . . . Now Oz takes an equally witty, equally melancholy look at his role as a writer.” —<i>Los Angeles Times</i><br/>  <br/> “From the prodigious Oz comes a delightfully elusive . . . story of imagination, talent and the transitory nature of fame. . . . Stamped with Oz’s charm and graceful skill in creating rich characters.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amos Oz, Nicholas de Lange
      </h2>
      
      <p class="authorDescription body article">Amos Oz was born in Jerusalem in 1939. He is the author of fourteen novels and collections of short fiction, and numerous works of nonfiction. His acclaimed memoir <I>A Tale of Love and Darkness</I> was an international bestseller and recipient of the prestigious Goethe Prize, as well as the National Jewish Book Award. <I>Scenes from Village Life</I>, a New York Times Notable Book, was awarded the Prix M&eacute;diterran&eacute;e &Eacute;tranger in 2010. Oz lives in Tel Aviv, Israel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55848130